import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import OptimizeImagesService from 'services/OptimizeImages.service';
import messages from './ArticleHeader.intl';
import styles from './ArticleHeader.module.scss';

@injectIntl
export default class ArticleHeaderComponent extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    cities: PropTypes.array.isRequired,
    country: PropTypes.string,
    background: PropTypes.string,
    traffitFormLink: PropTypes.string.isRequired,
    apply: PropTypes.string.isRequired,
    openInNewTab: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.traffitFormLink = props.traffitFormLink;
    this.apply = props.apply;
    this.openInNewTab = props.openInNewTab;
    this.state = {
      name: props.name,
      logo: props.logo,
      cities: props.cities,
      country: props.country,
      background: props.background
    };
  }

  static getDerivedStateFromProps(props, state) {
    const {
      name,
      cities,
      country,
      background,
      logo,
      traffitFormLink,
      apply,
      openInNewTab
    } = props;
    return {
      name,
      cities,
      country,
      background,
      logo,
      traffitFormLink,
      apply,
      openInNewTab
    };
  }

  render() {
    const { className, traffitFormLink, apply } = this.props;
    const { name, cities, country, background, logo } = this.state;
    return (
      <div className={`${styles.ArticleHeader} ${className}`}>
        {background && (
          <div
            className={styles.ArticleHeaderImage}
            style={{
              backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                background
              )})`
            }}
          />
        )}
        <div className={styles.ArticleHeaderBox}>
          <span className={styles.ArticleHeaderPosition}>
            {this.props.intl.formatMessage(messages.position)}
          </span>
          <div className={styles.ArticleHeaderTitle}>
            <span>{name}</span>
          </div>
          <div className={styles.ArticleHeaderCompanyLogo}>
            <img src={OptimizeImagesService.adjustImageSize(logo)} alt="" />
            <a
              href={traffitFormLink}
              target="_blank"
              rel="noreferrer"
              className={styles.DivTraffitLink}
            >
              <p className={styles.SpanTraffitLink}>{apply}</p>
            </a>
          </div>
          <div className={styles.ArticleHeaderCompanyInfo}>
            {cities.map(city => (
              <span key={city} className={styles.ArticleHeaderCategoryCity}>
                {city}
              </span>
            ))}
            {country && (
              <span className={styles.ArticleHeaderCategoryCountry}>
                {country}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/JobOfferArticle/components/Article/ArticleHeader/ArticleHeader.js